import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';
import {selectConfigurations} from 'coreStore/data/configurations';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useCustomerMgr custom hook
 */
export default function useConfigurations() {
	const {managerRepository} = useGeneralProvider();

	const configurations = useSelector((state) => selectConfigurations(state));

	return useVersioned(managerRepository.getConfigurationsMgr(), configurations);
}
